// extracted by mini-css-extract-plugin
module.exports = {"root":"BillingNotesGroupContainer_root__BD8Sq","tableWrap":"BillingNotesGroupContainer_tableWrap__4SIT8"};